var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    {
      class: _vm.keyboardIsOpen ? "keyboard-is-open" : "",
      attrs: { id: "app-layout", view: "hHh LpR lff" }
    },
    [
      _c(
        "q-layout-header",
        { ref: "layoutHeader" },
        [
          _c(
            "q-toolbar",
            { attrs: { color: _vm.$env === "production" ? "primary" : "red" } },
            [
              _vm.$route.meta.previousPage && _vm.$q.screen.lt.md
                ? _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "arrow_back_ios",
                      to: _vm.previousPageTo,
                      color: "white"
                    }
                  })
                : _vm._e(),
              _vm.menuItems.length
                ? _c("q-btn", {
                    attrs: { flat: "", round: "", dense: "", icon: "menu" },
                    on: {
                      click: function($event) {
                        _vm.drawers.left = !_vm.drawers.left
                      }
                    }
                  })
                : _vm._e(),
              _c("q-toolbar-title", [
                _c("div", { staticClass: "row gutter-x-sm items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "app.activities" } } },
                        [
                          _vm.$q.screen.lt.lg
                            ? _c("bj-icon", {
                                attrs: { width: 45, height: 45 }
                              })
                            : _c("bj-logo", {
                                attrs: { type: "inverted", height: 45 }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.$env !== "production" && _vm.$q.screen.gt.sm
                    ? _c(
                        "div",
                        { staticClass: "col-auto" },
                        [
                          _c(
                            "q-chip",
                            {
                              attrs: {
                                small: "",
                                color: "white",
                                "text-color": "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$env.toUpperCase()) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$q.screen.gt.sm &&
                  _vm.userRoleIs(
                    _vm.$config.roles.ADMIN,
                    _vm.$config.roles.SUPER_ADMIN
                  )
                    ? _c(
                        "div",
                        { staticClass: "col-auto" },
                        [
                          _c(
                            "q-chip",
                            {
                              attrs: {
                                small: "",
                                color: "white",
                                "text-color": "secondary"
                              }
                            },
                            [_vm._v("\n              ADMIN\n            ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "row gutter-x-sm items-center" }, [
                _c("div", { staticClass: "col-auto hidden" }, [
                  _c(
                    "div",
                    { staticClass: "row gutter-x-xs" },
                    _vm._l(_vm.menuItems, function(menuItem, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-auto" },
                        [
                          menuItem.children == undefined
                            ? _c("q-btn", {
                                attrs: {
                                  label: menuItem.label,
                                  flat: !_vm.isCurrentPage(menuItem),
                                  color: _vm.isCurrentPage(menuItem)
                                    ? "white"
                                    : "",
                                  "text-color": _vm.isCurrentPage(menuItem)
                                    ? "secondary"
                                    : "white",
                                  rounded: ""
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.redirect(menuItem.route)
                                  }
                                }
                              })
                            : _c(
                                "q-btn-dropdown",
                                {
                                  attrs: {
                                    label: menuItem.label,
                                    flat: !_vm.isCurrentPage(menuItem),
                                    color: _vm.isCurrentPage(menuItem)
                                      ? "white"
                                      : "",
                                    "text-color": _vm.isCurrentPage(menuItem)
                                      ? "secondary"
                                      : "white",
                                    rounded: ""
                                  }
                                },
                                [
                                  _c(
                                    "q-list",
                                    { attrs: { link: "" } },
                                    _vm._l(menuItem.children, function(
                                      childItem,
                                      index
                                    ) {
                                      return _c(
                                        "q-item",
                                        {
                                          directives: [
                                            {
                                              name: "close-overlay",
                                              rawName: "v-close-overlay"
                                            }
                                          ],
                                          key: index,
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.redirect(childItem.route)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-item-main",
                                            [
                                              _c(
                                                "q-item-tile",
                                                { attrs: { label: "" } },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(childItem.label) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    })
                  )
                ]),
                _vm.userRoleIs(
                  _vm.$config.roles.SUPER_ADMIN,
                  _vm.$config.roles.ADMIN
                )
                  ? _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _vm.$q.screen.gt.sm
                          ? _c("WideSearch", {
                              staticClass: "d-flex align-items-center",
                              staticStyle: { "min-width": "450px" }
                            })
                          : _c("q-btn", {
                              attrs: {
                                icon: "search",
                                flat: "",
                                round: "",
                                color: "white-4"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showSearchToolbar = !_vm.showSearchToolbar
                                }
                              }
                            })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.userRoleIs(_vm.$config.roles.AGENT)
                  ? _c("div", { staticClass: "col-auto" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "tel:" + _vm.getSetting("support_phone_number")
                          }
                        },
                        [
                          _c("q-btn", {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            attrs: {
                              round: "",
                              color: "white",
                              "text-color": "green",
                              icon: "call",
                              title: "Call support"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "col-auto" }, [
                  _c("div", { staticClass: "row items-center" }, [
                    _c("div", { staticClass: "col-auto" }, [
                      _c("img", {
                        attrs: {
                          id: "toolbar-user-avatar",
                          src: _vm.avatarUrl,
                          alt: "",
                          height: "42"
                        }
                      })
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _c(
                          "q-btn",
                          { attrs: { flat: "", rounded: "", "no-caps": "" } },
                          [
                            _c("q-icon", {
                              class: _vm.$q.screen.gt.sm ? "q-mr-sm" : "",
                              attrs: { name: "arrow_drop_down" }
                            }),
                            _c("div", {
                              staticClass: "text-left",
                              domProps: {
                                innerHTML: _vm._s(_vm.getHeaderDropdownLabel)
                              }
                            }),
                            _c(
                              "q-popover",
                              { attrs: { fit: "" } },
                              [
                                _c(
                                  "q-list",
                                  { attrs: { link: "", "no-border": "" } },
                                  [
                                    _c("q-list-header", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$q.screen.gt.sm
                                            ? "User"
                                            : _vm.get(
                                                _vm.$store.getters["auth/user"],
                                                "full_name"
                                              )
                                        )
                                      }
                                    }),
                                    _c(
                                      "q-item",
                                      {
                                        directives: [
                                          {
                                            name: "close-overlay",
                                            rawName: "v-close-overlay"
                                          }
                                        ],
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.redirect("app.profile")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-item-main",
                                          [
                                            _c(
                                              "q-item-tile",
                                              { attrs: { label: "" } },
                                              [
                                                _vm._v(
                                                  "\n                          Profile\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.userRoleIs(
                                      _vm.$config.roles.ACCOUNT_OWNER,
                                      _vm.$config.roles.MEMBER
                                    )
                                      ? _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.redirect(
                                                  "app.business.team"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "q-item-main",
                                              [
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { label: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                          Team\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "q-item",
                                      {
                                        directives: [
                                          {
                                            name: "close-overlay",
                                            rawName: "v-close-overlay"
                                          }
                                        ],
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.logout($event)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "q-item-main",
                                          [
                                            _c(
                                              "q-item-tile",
                                              { attrs: { label: "" } },
                                              [
                                                _vm._v(
                                                  "\n                          Sign out\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            1
          ),
          _vm.showSearchToolbar
            ? _c(
                "q-toolbar",
                [
                  _c("WideSearch", {
                    staticClass: "d-flex align-items-center full-width",
                    on: {
                      selected: function($event) {
                        _vm.showSearchToolbar = false
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.menuItems.length
        ? _c(
            "q-layout-drawer",
            {
              staticClass: "bg-primary",
              attrs: { side: "left" },
              model: {
                value: _vm.drawers.left,
                callback: function($$v) {
                  _vm.$set(_vm.drawers, "left", $$v)
                },
                expression: "drawers.left"
              }
            },
            [
              _c("div", { staticClass: "column justify-between full-height" }, [
                _c(
                  "div",
                  { staticClass: "col overflow-auto" },
                  [
                    _c(
                      "q-list",
                      {
                        staticClass: "q-pb-none",
                        attrs: { separator: "", link: "", "no-border": "" }
                      },
                      _vm._l(_vm.menuItems, function(item, index) {
                        return _c(
                          "div",
                          { key: item.label },
                          [
                            item.children
                              ? _c(
                                  "q-collapsible",
                                  {
                                    attrs: {
                                      label: item.label,
                                      icon: item.icon || "home",
                                      opened: _vm.isCurrentPage(item),
                                      "collapse-icon": "keyboard_arrow_down",
                                      "header-class": "drawer-menu-item"
                                    }
                                  },
                                  [
                                    _c(
                                      "q-list",
                                      { attrs: { link: "", "no-border": "" } },
                                      _vm._l(item.children, function(
                                        childItem
                                      ) {
                                        return _c(
                                          "router-link",
                                          {
                                            key: childItem.route,
                                            staticClass: "main-nav-link",
                                            attrs: {
                                              to: { name: childItem.route }
                                            }
                                          },
                                          [
                                            _c(
                                              "q-item",
                                              {
                                                staticClass:
                                                  "drawer-menu-item drawer-submenu-item",
                                                class: {
                                                  "q-item-selected": _vm.isCurrentPage(
                                                    childItem
                                                  )
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.menuItemClicked(
                                                      childItem
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("q-item-side", {
                                                  attrs: {
                                                    icon:
                                                      childItem.icon ||
                                                      "chevron_right"
                                                  }
                                                }),
                                                _c(
                                                  "q-item-main",
                                                  [
                                                    _c(
                                                      "q-item-tile",
                                                      { attrs: { label: "" } },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              childItem.label
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "router-link",
                                  {
                                    staticClass: "main-nav-link",
                                    attrs: { to: { name: item.route } }
                                  },
                                  [
                                    _c(
                                      "q-item",
                                      {
                                        key: index,
                                        staticClass: "drawer-menu-item",
                                        class: {
                                          "q-item-selected": _vm.isCurrentPage(
                                            item
                                          )
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            _vm.menuItemClicked(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-side", {
                                          attrs: { icon: item.icon || "home" }
                                        }),
                                        _c(
                                          "q-item-main",
                                          [
                                            _c(
                                              "q-item-tile",
                                              { attrs: { label: "" } },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.label) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      })
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-auto q-pa-sm",
                    attrs: { id: "drawer-essential-links" }
                  },
                  [
                    _c("div", { staticClass: "row gutter-x-sm gutter-y-xs" }, [
                      _c("div", { staticClass: "col-auto" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.showdigs.com/privacy",
                              target: "_blank"
                            }
                          },
                          [_vm._v("Privacy Policy")]
                        )
                      ]),
                      _c("div", { staticClass: "col-auto" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.showdigs.com/terms",
                              target: "_blank"
                            }
                          },
                          [_vm._v("Terms of Use")]
                        )
                      ]),
                      _c("div", { staticClass: "col-12" }, [
                        _c("small", { staticStyle: { "font-size": "12px" } }, [
                          _vm._v(
                            "\n              Bluejay Labs, Inc. All rights reserved © " +
                              _vm._s(new Date().getFullYear()) +
                              "\n              "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n              App version: v" +
                              _vm._s(_vm.$config.appVersion) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _c(
        "q-page-container",
        [
          _c(
            "q-page",
            { class: { "no-padding": _vm.$route.meta.noPadding } },
            [
              _vm.$route.meta.previousPage && _vm.$q.screen.gt.sm
                ? _c(
                    "div",
                    { staticClass: "q-mb-md" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            id: "back-button-desktop",
                            to: _vm.previousPageTo
                          }
                        },
                        [
                          _c("q-icon", { attrs: { name: "arrow_back_ios" } }),
                          _vm._v(
                            _vm._s(_vm.$route.meta.previousPage.label) +
                              "\n        "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.$route.meta.noTitle || _vm.$route.meta.title
                ? _c("div", {
                    staticClass: "q-mb-md",
                    attrs: { id: "page-title" },
                    domProps: { innerHTML: _vm._s(_vm.computedPageHeaderTitle) }
                  })
                : _vm._e(),
              _c("router-view", { key: _vm.$route.fullPath }),
              _vm.userRoleIs(
                _vm.$config.roles.ACCOUNT_OWNER,
                _vm.$config.roles.MEMBER
              ) && !_vm.$route.name.startsWith("app.properties.")
                ? _c(
                    "q-page-sticky",
                    { attrs: { position: "bottom-right", offset: [18, 18] } },
                    [
                      _c(
                        "q-fab",
                        {
                          attrs: {
                            color: "secondary",
                            icon: "add",
                            direction: "up"
                          }
                        },
                        [
                          _c(
                            "q-fab-action",
                            {
                              attrs: {
                                color: "secondary",
                                icon: "library_books"
                              },
                              on: { click: _vm.openAddInquiryModal }
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "center left",
                                    self: "center right",
                                    offset: [20, 0]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Add Inquiry\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-fab-action",
                            {
                              attrs: { color: "secondary", icon: "home" },
                              on: {
                                click: function($event) {
                                  _vm.redirect("app.properties.add")
                                }
                              }
                            },
                            [
                              _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "center left",
                                    self: "center right",
                                    offset: [20, 0]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Add Property\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("bj-add-inquiry-modal", { ref: "addInquiryModal" })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }